import React,{useState,useEffect,useContext} from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { ToastContainer, toast } from "react-toastify";
import moment from "jalali-moment";
import { AuthContextUser } from "../context/UserContext";
import Modal from "react-bootstrap/Modal";

export const ListHealt = () => {
    
    const { currentUser } = useContext(AuthContextUser);

    const [healt,setHealt] = useState([])
    const dateem = moment(new Date(), "YYYY-MM-DD").locale("fa").format("YYYY-MM-DD");
    
useEffect(() =>{
  const healtap = async() => {
    const res = await fetch(
        `https://clinic.salamatpayanew.ir/Register/healtList/${currentUser.nezam}&${dateem}`
        );
        setHealt(await res.json());
   }
       healtap()
},[healt])

const handelDelete = async(id) => {
    try{
        axios
       .delete(`https://clinic.salamatpayanew.ir/Register/deleteHEalt/${id}`)
       .then((response) => {
        setHealt((values) => {
           return values.filter((item) => item.id !== id);
         });
         toast.success("حذف  با موفقیت انجام شد");
       });
     }catch(err){
         toast.error("عملیات حذف غیر فعال میباشد")
     }
}

const [showb, setShowb] = useState(false);
const handleCloseb = () => setShowb(false);
const handleShowb = () => setShowb(true);


const handelShoew = async(ide,tele) => {  
    setTel(tele)
    handleShowb(true)
}
const [names,setNames] = useState('')
const [meli,setMsli] = useState('')
const [date,setDate] = useState('');
const [tel,setTel] = useState('');

const handelSubmitRow = async() => {
   await axios.post("https://clinic.salamatpayanew.ir/Register/patients",{
        name:names,
        meli:meli,
        tel:tel,
        year:date.replace("/","-").replace("/","-"),
        insu:date.replace("/","-").replace("/","-"),
        password:meli,
        nezam:currentUser.nezam,
    }).then(() =>{
        toast.success("عملیات ثبت اطلاعات بیمار با موفقیت انجام شد")
        handleCloseb(true)
    }).catch((err) =>{
        toast.warning("خطا در ثبت اطلاعات کاربر تکراری")
    })
}

if (currentUser.meli === null) {

} else {

return (
    <>
       <section class="m-0 content" dir='rtl'>
              <div class="row">
                <div class="table-responsive">
                    <table class="table bg-white custom-rounded t-24 table-responsive">
                        <thead>
                            <tr class="text-center">
                                 <th><span>ردیف</span></th>
                                <th><span>شماره تماس</span></th>
                                <th><span>تاریخ</span></th>
                                <th><span>نوبت گرفته شده</span></th>
                                <th><span>شماره پیگیری</span></th>
                                <th><span>روز</span></th>
                                <th><span>بیمار این پزشک</span></th>
                                <th><span>اضافه</span></th>
                                <th><span>حذف</span></th>
                            </tr>
                        </thead>
               {healt
                .map((item, index) => {
                    const { id, name,meli,tel,nezam,year } = item;
                  return (
                    <tbody
                      class="table-group-divider table-divider-color"
                      key={item.id}>
                            <tr>
                                <td>{index +1}</td>
                                <td>{item.tel}</td>
                                <td>{item.date}</td>
                                <td>{item.times}</td>
                                <td>{item.tokenIDR}</td>
                                <td>{item.day}</td>
                                <td>{item.ico}</td>
                                <td>
                                   <img src="/img/ok.png" height={"25px"} width={"25px"} style={{cursor:'pointer'}} onClick={() =>handelShoew(id,tel)} />
                                </td>
                                <td>
                                    <img src="/img/del.png" height={"25px"} width={"25px"} style={{cursor:'pointer'}} onClick={() =>handelDelete(id)} />
                                </td>
                            </tr>
                        </tbody>
                    );
                })}
                    </table>

                </div>
            </div>
        </section>
 <Modal show={showb} onHide={handleCloseb}>
   <Modal.Body>
         <input type='text' className='form-control col-sm-3' placeholder='نام و نام خانوادگی' onChange={(e)=> setNames(e.target.value)} />
         <input type='text' className='form-control col-sm-3' placeholder='کد ملی' onChange={(e)=> setMsli(e.target.value)}/>
         <input type='text' className='form-control col-sm-3' placeholder='تاریخ تولد' onChange={(e) => setDate(e.target.value)}/>
         <div style={{textAlign:'center'}} onClick={handelSubmitRow}><button className='btn btn-primary'>تایید اطلاعات</button></div>
   </Modal.Body>
</Modal>

    </>
  )
   }
}
